var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 11.8333V13.1666C2.66663 13.5202 2.8071 13.8594 3.05715 14.1094C3.3072 14.3595 3.64634 14.5 3.99996 14.5H12C12.3536 14.5 12.6927 14.3595 12.9428 14.1094C13.1928 13.8594 13.3333 13.5202 13.3333 13.1666V11.8333M4.66663 7.83329L7.99996 11.1666M7.99996 11.1666L11.3333 7.83329M7.99996 11.1666V3.16663",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1ee6077cf4264ffb379b479c44015d79.svg";
export { ForwardRef as ReactComponent };